// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__33if4","selects":"Documents_selects__27RUf"};